import { LocalizationService } from '@abp/ng.core';
import { ToasterService } from '@abp/ng.theme.shared';

export class NotificationHelper {
  static notificationList: Map<string, any> = new Map<string, any>();
}
